export var creatableOption = function (id, inputValue, onCreatedItem, retOptions, setInputValue) {
    return onCreatedItem &&
        onCreatedItem.length > 0 &&
        (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) &&
        !retOptions.some(function (x) { return x.label.toLowerCase() === inputValue.toLowerCase(); })
        ? [
            {
                creatable: true,
                label: "Create ".concat(inputValue),
                value: "Create ".concat(inputValue),
                onMouseDown: function () {
                    setInputValue('');
                    onCreatedItem({ id: id, value: inputValue });
                },
            },
        ]
        : [];
};
